import Alpine from 'alpinejs';

const REGEXES = {
    TRAILING_SLASH: /\/$/,
};

const currentPath = window.location.pathname.replace(REGEXES.TRAILING_SLASH, '') || '/';

function normalizeUrl(url: string): string {
    return url.replace(REGEXES.TRAILING_SLASH, '') || '/';
}

function isActive(url: string): boolean {
    if (!url) return false;
    const normalized = normalizeUrl(url);
    return currentPath === normalized || currentPath.startsWith(normalized + '/');
}

function isExactActive(url: string): boolean {
    if (!url) return false;
    return currentPath === normalizeUrl(url);
}

function isBestMatch(url: string, containerSelector: string, options?: { exact?: boolean }): boolean {
    if (!url) return false;
    const normalized = normalizeUrl(url);
    if (options?.exact) {
        return currentPath === normalized;
    }
    if (!isActive(normalized)) return false;
    const links = document.querySelectorAll<HTMLAnchorElement>(`${containerSelector} a[href]`);
    for (const link of links) {
        const href = normalizeUrl(link.getAttribute('href') || '');
        if (href !== normalized && href.length > normalized.length && isActive(href)) {
            return false;
        }
    }
    return true;
}

function hasActiveRight(): boolean {
    const rightLinks = document.querySelectorAll<HTMLAnchorElement>('[data-nav-top-right] a[href]');
    return Array.from(rightLinks).some((link) => isActive(link.pathname));
}

export function registerNavActive(): void {
    Alpine.store('nav', {
        isActive,
        isExactActive,
        isBestMatch,
        hasActiveRight,
    });
}
